import { HistoryViewModel } from '../../support/HistoryViewModel';
import { IOpenNoteOptions } from './IOpenNoteOptions';

const ADD_COMMENT_SEARCH_PARAM = 'addComment';

// How a note's care map route carries the way the note should open, written by whoever opens it and
// read back by the note's drawer page.
export class ViewNoteRouteSearch {
    static inject = () => [HistoryViewModel];
    constructor(private history: HistoryViewModel) {}

    // The search to append to a note's care map route so the note opens as the options ask.
    forOptions = ({ addComment }: IOpenNoteOptions = {}): string => {
        return addComment ? `?${ADD_COMMENT_SEARCH_PARAM}=${encodeURIComponent(addComment)}` : '';
    };

    // The comment focus request the current route carries, if any.
    getCommentFocusRequest = (): string | undefined => {
        return this.history.getCurrentSearchParams().get(ADD_COMMENT_SEARCH_PARAM) ?? undefined;
    };
}
